import { render, staticRenderFns } from "./user_add.vue?vue&type=template&id=5060bfce&scoped=true&"
import script from "./user_add.vue?vue&type=script&lang=js&"
export * from "./user_add.vue?vue&type=script&lang=js&"
import style0 from "./user_add.vue?vue&type=style&index=0&id=5060bfce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5060bfce",
  null
  
)

export default component.exports